export default (rawUrl, width, quality) => {
  if (!rawUrl) {
    return '';
  }

  rawUrl = rawUrl.replace('https://s3.ap-northeast-2.amazonaws.com/images.qa', `${process.env.VUE_APP_IMAGE_BASE_URL}`);
  rawUrl = rawUrl.replace('https://image.dev.o-lens.com', `${process.env.VUE_APP_IMAGE_BASE_URL}`);
  const params = {
    w: width,
    q: quality
  };
  let query = Object.keys(params)
      .filter(key => params[key])
      .map(key => `${key}=${params[key]}`)
      .join('&');

  if (query) {
    query = `?${query}`;
  }

  return rawUrl && rawUrl.startsWith('data:') && rawUrl
      || rawUrl && (rawUrl.startsWith('http') || rawUrl.startsWith('/img/') || rawUrl.startsWith('/images/')) && `${rawUrl + query}`
      || rawUrl && `${process.env.VUE_APP_IMAGE_BASE_URL}/${rawUrl + query}`;
};